<style lang="scss">
.post-reply-fail-page{
  .fake-checkbox {
    font-size: 15pt;

    .fa-check-square {
      color: $purple-blue;
      border: 1px solid transparent;
    }

    .fa-square{
      color: white;
      border: 1px solid #D8D6DE;
      border-radius: 3px;
    }
  }
}
</style>

<template>
  <!-- eslint-disable -->
  <div class="post-reply-fail-page mb-4">
    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>Status</label>
          <b-form-select @change="updateFilterItemAndSetSearch('status', $event)" :value="filters.status" class="mb-1" cy="status-select">
            <b-form-select-option value="">All</b-form-select-option>
            <b-form-select-option value="Unacknowledged">Unacknowledged</b-form-select-option>
            <b-form-select-option value="Acknowledged">Acknowledged</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3">
          <label>Before Date</label>
          <b-form-datepicker :value="filters.before" locale="en-uk"
                             @input="updateFilterItemAndSetSearch('before', $event)"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-3">
          <label>After Date</label>
          <b-form-datepicker :value="filters.after" locale="en-uk"
                             @input="updateFilterItemAndSetSearch('after', $event)"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="updateFilterItemAndSetSearch('sort', $event)" :value="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-12 d-flex align-items-center full-width" style="margin-top: 5px">
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchFailedReplies()">Search</b-button>
          <div class="ui-spacer"></div>
          <b-button @click="searchFailedReplies()"><i class="fas fa-sync"></i></b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="replies"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
          selectable
          ref="selectableTable"
          @row-selected="onRowSelected"
          :select-mode="'multi'"
        >
          <template #cell(selected)="{ rowSelected }">
            <span class="fake-checkbox"><i class="fas" :class="rowSelected ? 'fa-check-square' : 'fa-square'"></i></span>
          </template>

          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(created_at)="data">
            {{data.item.created_at | formatDateTime}}
          </template>
          <template #cell(actions)="data">
            <router-link :to="{ name: 'failed-reply-details', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination @change="getFailedReplies()" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No records</p>
        </b-row>
        <b-row class="p-2 pl-3">
          <b-button class="mr-1" size="sm" @click="$refs.selectableTable.selectAllRows()">Select all</b-button>
          <b-button size="sm" @click="$refs.selectableTable.clearSelected()">Clear selected</b-button>
          <div class="ui-spacer"></div>
          <b-button :class="{'disabled': selectedRows.length === 0 || updating}" variant="success"
                    @click="$bvModal.show('modal-acknowledge')">Acknowledge Selected</b-button>
        </b-row>
      </section>
    </b-card>

    <b-modal id="modal-acknowledge" title="Acknowlegde Failure" hide-footer>
      <warning-modal v-if="selectedRows" @close="closeModals()" @ok="bulkAcknowledge()"
                     title="Are you sure you wish to acknowledge these failures?"></warning-modal>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import {mapState} from 'vuex';
import WarningModal from '@/components/modals/WarningModal.vue';
import HelperService from '../../services/HelperService';
import RepliesService from '../../services/RepliesService';

export default {
  name: 'PostReplyFails',
  components: {
    WarningModal,
  },
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      headers: [
        { label: '', key: 'selected' },
        { label: 'Filename', key: 'filename' },
        { label: 'Status', key: 'status' },
        { label: 'Reason', key: 'fail_status' },
        { label: 'Created', key: 'created_at' },
        { label: '', key: 'actions' },
      ],
      replies: [],
      currentPage: 1,
      totalRows: 10,
      selectedRows: [],
      updating: false,
    };
  },
  computed: {
    ...mapState({
      filters: state => state.failedReplies.filters,
    }),
  },
  watch: {
    currentPage() {
      this.getFailedReplies();
    },
    $route() {
      this.setUp();
    },
  },
  mounted() {
    this.$store.dispatch('failedReplies/setFiltersFromLocal');
    this.setUp();
  },
  methods: {
    setUp() {
      this.getFailedReplies();
    },
    searchFailedReplies() {
      this.currentPage = 1;

      this.getFailedReplies();
    },
    getFailedReplies() {
      this.filters.skip = (this.currentPage - 1) * this.filters.limit;

      RepliesService.getFailedReplies(this.filters).then(res => {
        this.loading = false;
        this.replies = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting replies ', err);
        this.$toast.error('Could not get failed replies, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    updateFilterItemAndSetSearch(filterKey, value) {
      this.$store.commit('failedReplies/SET_FILTER_ITEM', { name: filterKey, value });
      this.searchFailedReplies();
    },
    clearFilters() {
      this.$store.dispatch('failedReplies/clearFilters');
      this.searchFailedReplies();
    },
    onRowSelected(items) {
      this.selectedRows = items;
    },
    bulkAcknowledge() {
      this.closeModals();
      this.updating = true;

      RepliesService.bulkAcknowledgeReplies({ ids: this.getIdsFromSelectedRows() }).then(() => {
        this.$toast.success('Bulk updated status to Acknowledged Successfully', {
          toastClassName: ['toast-std', 'success-toast'],
        });
        this.getFailedReplies(); // refresh
      }).catch(err => {
        console.log('could not update status', err);
        this.$toast.error('Could not bulk set status to acknowledged, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.updating = false;
      })
    },
    getIdsFromSelectedRows() {
      return this.selectedRows.map(item => {return item._id});
    },
    closeModals() {
      this.$bvModal.hide('modal-acknowledge');
    },
  },
};
</script>
